var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchValidated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11598_39064)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5362 4.51418V5.47847C12.5362 5.56686 12.4639 5.63918 12.3755 5.63918H4.66119C4.57279 5.63918 4.50047 5.56686 4.50047 5.47847V4.51418C4.50047 4.42579 4.57279 4.35347 4.66119 4.35347H12.3755C12.4639 4.35347 12.5362 4.42579 12.5362 4.51418ZM4.50047 7.40704C4.50047 7.31865 4.57279 7.24633 4.66119 7.24633H8.35761C8.44601 7.24633 8.51833 7.31865 8.51833 7.40704V8.37133C8.51833 8.45972 8.44601 8.53204 8.35761 8.53204H4.66119C4.57279 8.53204 4.50047 8.45972 4.50047 8.37133V7.40704ZM2.89333 16.3267H7.55404C7.64244 16.3267 7.71476 16.399 7.71476 16.4874V17.6124C7.71476 17.7008 7.64244 17.7731 7.55404 17.7731H2.08976C1.73418 17.7731 1.4469 17.4858 1.4469 17.1303V1.38025C1.4469 1.02467 1.73418 0.737396 2.08976 0.737396H14.9469C15.3025 0.737396 15.5898 1.02467 15.5898 1.38025V9.09454C15.5898 9.18293 15.5174 9.25525 15.429 9.25525H14.304C14.2156 9.25525 14.1433 9.18293 14.1433 9.09454V2.18382H2.89333V16.3267Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2143 9.57501C9.81763 9.57501 7.875 11.5176 7.875 13.9143C7.875 16.3109 9.81763 18.2536 12.2143 18.2536C14.6109 18.2536 16.5536 16.3109 16.5536 13.9143C16.5536 11.5176 14.6109 9.57501 12.2143 9.57501ZM13.1123 12.3875H14.0022C14.1328 12.3875 14.2092 12.5362 14.1308 12.6426L11.8366 15.8168C11.7723 15.9051 11.6417 15.9051 11.5775 15.8168L10.0949 13.7656C10.0185 13.6592 10.0949 13.5105 10.2254 13.5105H11.1114C11.1369 13.5103 11.162 13.5162 11.1848 13.5277C11.2075 13.5393 11.2271 13.5561 11.242 13.5768L11.706 14.2176L12.9817 12.4538C13.0118 12.4116 13.06 12.3875 13.1123 12.3875Z",
    fill: "#52C41A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11598_39064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchValidated);
export default __webpack_public_path__ + "static/media/BatchValidated.98f937c43e926351b1a2dd6102dc29b7.svg";
export { ForwardRef as ReactComponent };